export default "/react/modal-medicine-1721df82.png";